import Silouhette from "../../../Assets/silhouette.webp"
import Flower from "../../../Assets/Flower.webp";
import NewsPaper from "../../../Assets/Good Design.webp";
import WeirdThing from "../../../Assets/weirdsomething.webp";
import Gold from "../../../Assets/goldPic.webp";
import Jams from "../../../Assets/jamsEarn.webp";






export const data = [
    {
        img: Silouhette,
        press: "3.28.23",
        heading: "Introducing REV by LYFT"
    },
    {
        img: Flower,
        press: "4.11.33",
        heading: "BASIC/DEPT® is Ad Age's A-List Design & Branding Agency of the Year"
    },
    {
        img: NewsPaper,
        press: "67.1.45",
        heading: "The Principles of Good Design: Good Design is Glamorous"
    },
    {
        img: WeirdThing,
        press: "99.99.01",
        heading: "5 ways to fall in love with learning about accessibility "
    },
    {
        img: Gold,
        press: "1.1.1.1",
        heading: "How brands can represent people with disabilities with authenticity"
    },
    {
        img: Jams,
        press: "1.1.1.1",
        heading: "How apparel brands can embrace gender fluidity in the metaverse"
    },
]